import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CacheKeys } from '@micro-core/environment';
import moment from 'moment';
import { BsCacheService } from '../Cache/bs-cache.service';

// Saved in the cache, not redirectUrl, so the request survives sign-in, sign-up, and onboarding.
export const chatLinkGuard: CanActivateFn = (route) => {
  inject(BsCacheService).setItem(CacheKeys.PendingChatLink, true, {
    expires: moment().add(60000, 'seconds').valueOf(),
  });
  return inject(Router).createUrlTree(['/home'], { queryParams: route.queryParams });
};
